import { getRestClient } from "services/restClient"

const useRestClient = () => {
  const { restClient } = getRestClient()
  return { restClient }
}

export default useRestClient
